import React, { useRef, useState } from 'react';

/**
 * Glass card that lights up under the pointer. The highlight is driven by CSS
 * custom properties rather than React state so moving the mouse never
 * re-renders the tree.
 */
export default function SpotlightCard({
  as: Tag = 'div',
  className = '',
  spotlightClassName = '',
  children,
  ...rest
}) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  const handleMove = (event) => {
    const node = ref.current;
    if (!node) return;
    const rect = node.getBoundingClientRect();
    node.style.setProperty('--spot-x', `${event.clientX - rect.left}px`);
    node.style.setProperty('--spot-y', `${event.clientY - rect.top}px`);
  };

  return (
    <Tag
      ref={ref}
      onPointerMove={handleMove}
      onPointerEnter={() => setActive(true)}
      onPointerLeave={() => setActive(false)}
      className={`group relative overflow-hidden surface surface-hover ${className}`}
      {...rest}
    >
      <span
        aria-hidden="true"
        className={`pointer-events-none absolute inset-0 transition-opacity duration-500 ${
          active ? 'opacity-100' : 'opacity-0'
        } ${spotlightClassName}`}
        style={{
          background:
            'radial-gradient(340px circle at var(--spot-x, 50%) var(--spot-y, 50%), rgba(63,140,255,0.14), transparent 70%)'
        }}
      />
      <div className="relative h-full">{children}</div>
    </Tag>
  );
}
